export default "__VITE_ASSET__BRVaOEqY__"